import React, { useCallback } from 'react';
import {
  useSelector, useDispatch, batch,
} from 'react-redux';

import { Tappable, HorizontalScrollView } from '@common/ui/general';
import {
  getAchievementData,
  showAchievementsModal,
} from '@profile/store/achievementSection';
import HappyFlowShareableModal
  from '~referral/components/NudgeHappyFlow/ModalType/HappyFlowShareableModal';
import { fetchRcbSource } from '~referral/stores/referralCallback';
import tipIcon from '@profile/images/achievements/tip.webp';
import PspMilestoneNudge
  from '@profile/images/achievements/psp-milestone-nudge.webp';
import PostPlacementNudge
  from '@profile/images/achievements/post-placement-nudge.webp';
import TwelveMonthsNudge
  from '@profile/images/achievements/12_months_nudge.webp';
import ThreeMonthsNudge from '@profile/images/achievements/3_months_nudge.webp';
import SixMonthsNudge from '@profile/images/achievements/6_months_nudge.webp';
import NineMonthsNudge from '@profile/images/achievements/9_months_nudge.webp';
import ProblemSolvedNudge
  from '@profile/images/achievements/problem_solved_nudge.webp';

const bannerImage = (label) => {
  if (label?.endsWith('_solved_problems_nudge')) {
    return ProblemSolvedNudge;
  }
  switch (label) {
    case 'post_placement_nudge':
      return PostPlacementNudge;
    case 'psp_milestone_nudge':
      return PspMilestoneNudge;
    case 'post_3_months_nudge':
      return ThreeMonthsNudge;
    case 'post_6_months_nudge':
      return SixMonthsNudge;
    case 'post_9_months_nudge':
      return NineMonthsNudge;
    case 'post_12_months_nudge':
      return TwelveMonthsNudge;
    default:
      return null;
  }
};

function Carousel() {
  const dispatch = useDispatch();
  const achievementState = useSelector((state) => state.achievementSection);
  const {
    shareableLink,
    showAchievementModal,
    isLoading,
  } = useSelector((state) => state.achievementSection);
  const happyFlowNudgeData = { sharable_links: shareableLink };
  const isAchievementModalActive = shareableLink
        && showAchievementModal && !isLoading;

  const onCloseModal = useCallback(() => {
    dispatch(showAchievementsModal(!showAchievementModal));
  }, [showAchievementModal, dispatch]);

  const showModal = useCallback((index) => {
    batch(() => {
      dispatch(fetchRcbSource('Shareable Panel Profile Page'));
      dispatch(getAchievementData(achievementState.achievements[index]));
      onCloseModal();
    });
  }, [achievementState.achievements, dispatch, onCloseModal]);

  return (
    <div className="achievement-panel">
      { isAchievementModalActive && (
        <HappyFlowShareableModal
          onCloseModal={onCloseModal}
          nudgeData={happyFlowNudgeData}
          nudgeType={achievementState.nudgeLabel}
        />
      )}

      <div className="achievement-panel__header-section">
        <span className="achievement-panel--header">My Achievements</span>
        <span className="achievement-panel--new">New</span>
      </div>
      <div className="achievement-panel__wrapper">
        <div className="achievement-panel__scroller">
          <HorizontalScrollView
            leftArrowIcon="chevron-left"
            rightArrowIcon="chevron-right"
            step={295}
          >
            {achievementState.achievements.map((obj, index) => (
              <Tappable
                className="achievement-panel__scroller-child no-highlight"
                key={obj}
                onClick={() => showModal(index)}
              >
                <img
                  className="achievement-panel__achievement-image"
                  src={bannerImage(obj.split('#')[1])}
                  alt="banner"
                />
              </Tappable>
            ))}
          </HorizontalScrollView>
        </div>
      </div>
      <div className="achievement-panel__footer-section">
        <img
          className="achievement-panel__footer-section--tip"
          src={tipIcon}
          alt="tip"
        />
        Once you activate your Public Profile, this section will not be visible
        to those who open your profile link.
      </div>
    </div>
  );
}

export default Carousel;
